import { useEffect, useState } from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import Spinner from "@atlaskit/spinner";

import { useSearchParameters } from "@/components/signup/hooks";
import { DataFoundationsWrapper } from "@/utils/data-foundations/data-foundation-types";

import { JiraOnboardingContainer } from "../../components/jira-onboarding-container/jira-onboarding-container";
import { useScreenManager } from "../../hooks/use-screen-manager";
import { getPrimaryProduct } from "../../hooks/utils/use-cloud-status-utils";
import { UserSegmentationTeamType } from "../../models/user-segmentation";
import {
    isEligibleTeamTypeToViewJtbdScreen,
    useGetTeamTypeData
} from "../../utils/utils";

import Buttons from "./components/buttons";
import CheckboxGrid from "./components/checkbox-grid";
import { checkboxValues } from "./constants";
import { messages } from "./messages";

const spinnerStyles = css({
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    minHeight: "100vh"
});

const JtbdView = () => {
    const [isLoading, setIsLoading] = useState(true);
    const { skipScreen } = useScreenManager();
    const intl = useIntl();

    const { teamType, teamTypeCheckboxes, isSoftwareTeamType } =
        useGetTeamTypeData();

    const [checkboxes, setCheckboxes] = useState(teamTypeCheckboxes);

    const handleCheckboxChange = (checkboxes: checkboxValues[]) => {
        setCheckboxes(checkboxes);
    };

    const { products, edition } = useSearchParameters();
    const productKey = getPrimaryProduct(products);
    const dataFoundationAttributes = {
        productKey,
        edition,
        teamType
    };

    useEffect(() => {
        const canViewScreen =
            teamType &&
            isEligibleTeamTypeToViewJtbdScreen(
                teamType as UserSegmentationTeamType
            );

        if (canViewScreen) {
            setIsLoading(false);
        } else {
            skipScreen();
        }
    }, [skipScreen, teamType]);

    if (checkboxes === undefined || teamType === undefined) {
        skipScreen();
        return;
    }

    const countTrue = () => {
        let count = 0;
        checkboxes.forEach((checkbox) => {
            if (checkbox.isChecked) {
                count++;
            }
        });
        return count;
    };

    const numSelected = countTrue();

    if (isLoading) {
        return (
            <div css={spinnerStyles} role="progressbar" aria-label={"loading"}>
                <Spinner size="xlarge" />
            </div>
        );
    }

    const view = (
        <JiraOnboardingContainer
            header={intl.formatMessage({
                id: messages.header.id,
                defaultMessage: messages.header.defaultMessage
            })}
            subheader={intl.formatMessage({
                id: messages.subHeader.id,
                defaultMessage: messages.subHeader.defaultMessage
            })}
            hideSubHeader={isSoftwareTeamType}
            hideFooterOnMobile={true}
        >
            <CheckboxGrid
                checkboxes={checkboxes}
                handleCheckboxChange={handleCheckboxChange}
                // errorState={errorState}
                // handleErrorChange={handleErrorChange}
                numSelected={numSelected}
                header={intl.formatMessage({
                    id: messages.chooseOptions.id,
                    defaultMessage: messages.chooseOptions.defaultMessage
                })}
                disableSelectionLimit={isSoftwareTeamType}
            />
            <Buttons
                checkboxes={checkboxes}
                teamType={teamType}
                // handleErrorChange={handleErrorChange}
            />
        </JiraOnboardingContainer>
    );

    return (
        <DataFoundationsWrapper
            dataFoundationsEventOption="JTBDScreenViewed"
            attributes={dataFoundationAttributes}
        >
            {view}
        </DataFoundationsWrapper>
    );
};

export default JtbdView;
